var _path, _path2, _path3, _path4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedalDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 51,
    viewBox: "0 0 46 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9312 1.75941L3.97671 11.0664C2.13344 12.1417 1 14.1151 1 16.2491V34.7509C1 36.8849 2.13344 38.8583 3.97671 39.9336L19.9312 49.2406C21.7955 50.3282 24.1004 50.3306 25.967 49.2469L42.0125 39.9315C43.8618 38.8579 45 36.881 45 34.7426V16.2574C45 14.119 43.8618 12.1421 42.0125 11.0685L25.967 1.75312C24.1003 0.669446 21.7955 0.671849 19.9312 1.75941Z",
    fill: "white",
    stroke: "#ECE9F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9053 3.80173L5.94591 12.0567C4.12005 13.1364 3 15.1 3 17.2212V33.7788C3 35.9 4.12005 37.8636 5.94591 38.9433L19.9053 47.1983C21.7851 48.3099 24.1204 48.3124 26.0026 47.2047L40.0432 38.9414C41.8752 37.8632 43 35.8961 43 33.7704V17.2296C43 15.1038 41.8752 13.1368 40.0432 12.0586L26.0026 3.79533C24.1204 2.68764 21.7851 2.69009 19.9053 3.80173Z",
    fill: "#DD5034"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4083 7.67405L9.94057 13.8788C8.11773 14.9593 7 16.9212 7 19.0402V31.5562C7 33.6752 8.11773 35.6371 9.94057 36.7176L20.4083 42.9224C22.2908 44.0383 24.6315 44.0407 26.5163 42.9288L37.0486 36.7157C38.8776 35.6367 40 33.6714 40 31.5479V19.0486C40 16.9251 38.8776 14.9597 37.0486 13.8808L26.5163 7.66763C24.6315 6.55574 22.2908 6.5582 20.4083 7.67405Z",
    fill: "#FF726C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_536_778",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 6,
    width: 33,
    height: 38
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4083 7.67405L9.94057 13.8788C8.11773 14.9593 7 16.9212 7 19.0402V31.5562C7 33.6752 8.11773 35.6371 9.94057 36.7176L20.4083 42.9224C22.2908 44.0383 24.6315 44.0407 26.5163 42.9288L37.0486 36.7157C38.8776 35.6367 40 33.6714 40 31.5479V19.0486C40 16.9251 38.8776 14.9597 37.0486 13.8808L26.5163 7.66763C24.6315 6.55574 22.2908 6.5582 20.4083 7.67405Z",
    fill: "#7B63BF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_536_778)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 6.86484,
    width: 16,
    height: 37,
    fill: "#FF726C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalDanger);
export default __webpack_public_path__ + "static/media/medalDanger.75ac76938ab8d23955e2d9899f29913d.svg";
export { ForwardRef as ReactComponent };